
import { Vue, Options, prop } from "vue-class-component";
import { Commodity } from "@/domain/entities/Commodity";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { debounce } from "lodash";
import { RequestListCommodity } from "@/data/payload/api/CommodityApiRequest";
import { CommodityController } from "@/app/ui/controllers/CommodityController";
import { CommodityData } from "@/domain/entities/BulkBooking";
import ModalAllCommodity from "../../comodity/modal-all-commodity.vue";
import {
  DocInternationalModelValueType,
  CommodityCIPL,
  ErrorBookingV3
} from "@/domain/entities/CreateBookingV3";
import { parseZodError } from "../../../utils";
import {
  emailSchema,
  idNumberSchema,
  taxNumberSchema,
  itemDetailSchema,
  quantitySchema,
  goodsPriceSchema,
  imageSchema
} from "./validation";
import { RequestInternationalDocumentDetail } from "@/domain/entities/InternationalDocument";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { BookingController } from "@/app/ui/controllers/BookingController";
import {
  DeleteHydraFileRequest,
  UploadHydraFileRequest
} from "@/data/payload/api/BookingRequest";
import { SttAdjustmentRule } from "@/domain/entities/ShipmentBooking";
import { UploadMultiple, OptionsClass } from "@/domain/entities/MainApp";
import {
  formatInputMoney,
  formatInputMoneyWithDecimal,
  formatInputNumberOnly,
  formatInputNumberOnlyV2,
  maskBankAccountName,
  numberOnly
} from "@/app/infrastructures/misc/Utils";
import { ConfigValidationForm } from "@/domain/entities/CreateBookingV3";
import { formatInputNoDecimal } from "@/app/infrastructures/misc/common-library/FormatInputNoDecimal";
import { formatNumberOnlyWithZero } from "@/app/infrastructures/misc/common-library/FormatNumberOnlyWithZero";
import absolutePosition from "@/app/infrastructures/misc/common-library/dom/absolutePosition";

class Props {
  modelValue = prop<DocInternationalModelValueType>({
    required: true,
    default: () => new DocInternationalModelValueType()
  });
  id = prop<string>({
    required: true,
    default: "international-document"
  });
  originCityId = prop<number>({
    required: true,
    default: 0
  });
  destinationCityId = prop<number>({
    required: true,
    default: 0
  });
  isFtz = prop<boolean>({
    required: true,
    default: false
  });
  indexListCommodityCIPL = prop<number>({
    required: true
  });
  indexEmail = prop<number>({
    required: true
  });
  indexTaxNumber = prop<number>({
    required: true
  });
  indexShipmentStatus = prop<number>({
    required: true
  });
  indexIdNumber = prop<number>({
    required: true
  });
  indexImageBeforePackingUrl = prop<number>({
    required: true
  });
  indexImageAfterPackingUrl = prop<number>({
    required: true
  });
  indexImageIdUrl = prop<number>({
    required: true
  });
  indexImageTaxUrl = prop<number>({
    required: true
  });
  currentIndex = prop<number>({
    required: true
  });
  error = prop<ErrorBookingV3>({
    type: Object,
    required: true
  });
  internationalDocumentDetailData = prop<RequestInternationalDocumentDetail>({
    type: Object,
    required: true,
    default: () => new RequestInternationalDocumentDetail()
  });
  configFtzCipl = prop<SttAdjustmentRule>({
    default: new SttAdjustmentRule(),
    type: Object
  });
  configFtzIdentityNo = prop<SttAdjustmentRule>({
    default: new SttAdjustmentRule(),
    type: Object
  });
  configFtzTaxNo = prop<SttAdjustmentRule>({
    default: new SttAdjustmentRule(),
    type: Object
  });
  configFtzEmail = prop<SttAdjustmentRule>({
    default: new SttAdjustmentRule(),
    type: Object
  });
  configFtzImageTaxNo = prop<SttAdjustmentRule>({
    default: new SttAdjustmentRule(),
    type: Object
  });
  configFtzImageEmail = prop<SttAdjustmentRule>({
    default: new SttAdjustmentRule(),
    type: Object
  });
  configFtzImageBeforePacking = prop<SttAdjustmentRule>({
    default: new SttAdjustmentRule(),
    type: Object
  });
  configFtzImageAfterPacking = prop<SttAdjustmentRule>({
    default: new SttAdjustmentRule(),
    type: Object
  });
  configFtzShipmentStatus = prop<SttAdjustmentRule>({
    default: new SttAdjustmentRule(),
    type: Object
  });
  configInterCipl = prop<SttAdjustmentRule>({
    default: new SttAdjustmentRule(),
    type: Object
  });
  configInterEmail = prop<SttAdjustmentRule>({
    default: new SttAdjustmentRule(),
    type: Object
  });
  configInterIdentityNo = prop<SttAdjustmentRule>({
    default: new SttAdjustmentRule(),
    type: Object
  });
  configInterTaxNo = prop<SttAdjustmentRule>({
    default: new SttAdjustmentRule(),
    type: Object
  });
  configInterImageAfterPacking = prop<SttAdjustmentRule>({
    default: new SttAdjustmentRule(),
    type: Object
  });
  configInterImageBeforePacking = prop<SttAdjustmentRule>({
    default: new SttAdjustmentRule(),
    type: Object
  });
  configInterImageTaxNo = prop<SttAdjustmentRule>({
    default: new SttAdjustmentRule(),
    type: Object
  });
  configInterImageEmail = prop<SttAdjustmentRule>({
    default: new SttAdjustmentRule(),
    type: Object
  });
  configInterDutyTaxTerms = prop<SttAdjustmentRule>({
    default: new SttAdjustmentRule(),
    type: Object
  });
  isEditSttMY = prop<boolean>({
    default: false
  });
  clientCountry = prop<string>({
    default: ""
  });
  isRetail = prop<boolean>({
    default: false
  });
};

@Options({
  components: {
    Commodity,
    ModalAllCommodity
  },
  watch: {
    currentIndex: {
      handler(index = 0) {
        this.updateFIeldIndex(index);
      },
      deep: true
    },
    internationalDocumentDetailData: {
      handler() {
        this.resetErrorChangeDest();
      }
    },
    "listCommodityCIPL.length": {
      handler(length: number) {
        if (!length) this.onAddCIPL(true);
      }
    }
  }
})
export default class DocInternational extends Vue.with(Props) {
  dataListCommodities: Commodity[] = [];
  errorCommodity = false;
  isCommodityNotFound = false;
  isModalViewAll = false;
  isFocused = false;
  selectedCIPLIndex = 0;
  MAX_CIPL = 15;
  imageIdUrlTemp = "";
  imageTaxUrlTemp = "";
  imageAfterPackingUrlTemp = "";
  imageBeforePackingUrlTemp = "";

  async mounted() {
    if (!this.listCommodityCIPL.length) {
      this.onAddCIPL(true);
    } else {
      this.error.listCommodityCIPLDocInternational = [];
      this.listCommodityCIPL.forEach(() => {
        this.error.listCommodityCIPLDocInternational.push(["", "", ""]);
      });
    }

    this.initShipmentStatus();

    if (!this.isFtz) this.$emit("fetch-config");
  }

  get getRuleTFtzCiplDisabled() {
    return this.configFtzCipl.rule.includes(ConfigValidationForm.NON_EDITABLE);
  }

  get getRuleTFtzIdentityNoDisabled() {
    return this.configFtzIdentityNo.rule.includes(
      ConfigValidationForm.NON_EDITABLE
    );
  }

  get getRuleTFtzTaxNoDisabled() {
    return this.configFtzTaxNo.rule.includes(ConfigValidationForm.NON_EDITABLE);
  }

  get getRuleTFtzEmailDisabled() {
    return this.configFtzEmail.rule.includes(ConfigValidationForm.NON_EDITABLE);
  }

  get getRuleTFtzImageTaxNoDisabled() {
    return this.configFtzImageTaxNo.rule.includes(
      ConfigValidationForm.NON_EDITABLE
    );
  }

  get getRuleTFtzImageEmailDisabled() {
    return this.configFtzImageEmail.rule.includes(
      ConfigValidationForm.NON_EDITABLE
    );
  }

  get getRuleTFtzImageBeforePackingDisabled() {
    return this.configFtzImageBeforePacking.rule.includes(
      ConfigValidationForm.NON_EDITABLE
    );
  }

  get getRuleTFtzImageAfterPackingDisabled() {
    return this.configFtzImageAfterPacking.rule.includes(
      ConfigValidationForm.NON_EDITABLE
    );
  }

  get getRuleTFtzShipmentStatusDisabled() {
    return this.configFtzShipmentStatus.rule.includes(
      ConfigValidationForm.NON_EDITABLE
    );
  }

  get getRuleTInterCiplDisabled() {
    return this.configInterCipl.rule.includes(
      ConfigValidationForm.NON_EDITABLE
    );
  }

  get getRuleTInterIdentityNoDisabled() {
    return this.configInterIdentityNo.rule.includes(
      ConfigValidationForm.NON_EDITABLE
    );
  }

  get getRuleTInterTaxNoDisabled() {
    return this.configInterTaxNo.rule.includes(
      ConfigValidationForm.NON_EDITABLE
    );
  }

  get getRuleTInterEmailDisabled() {
    return this.configInterEmail.rule.includes(
      ConfigValidationForm.NON_EDITABLE
    );
  }

  get getRuleTInterImageTaxNoDisabled() {
    return this.configInterImageTaxNo.rule.includes(
      ConfigValidationForm.NON_EDITABLE
    );
  }

  get getRuleTInterImageEmailDisabled() {
    return this.configInterImageEmail.rule.includes(
      ConfigValidationForm.NON_EDITABLE
    );
  }

  get getRuleTInterImageBeforePackingDisabled() {
    return this.configInterImageBeforePacking.rule.includes(
      ConfigValidationForm.NON_EDITABLE
    );
  }

  get getRuleTInterImageAfterPackingDisabled() {
    return this.configInterImageAfterPacking.rule.includes(
      ConfigValidationForm.NON_EDITABLE
    );
  }

  get getRuleTInterDutyTaxTermsDisabled() {
    return this.configInterDutyTaxTerms.rule.includes(ConfigValidationForm.NON_EDITABLE);
  }

  get listCommodityCIPL() {
    return this.modelValue.listCommodityCIPL || [];
  }

  set listCommodityCIPL(val: CommodityCIPL[]) {
    this.$emit("update:modelValue.listCommodityCIPL", val);
  }

  get isClientID() {
    const clientCountry = this.clientCountry;
    if (!clientCountry) return true;
    return clientCountry.toLowerCase() === "id";
  }

  get accountIsNonForeign() {
    return !AccountController.accountData.accountIsForeign && this.isClientID;
  }

  get commodities() {
    return this.dataListCommodities.map((item) => {
      return {
        id: item.commodity_id,
        name: this.accountIsNonForeign
          ? item.commodity_name
          : item.commodity_name_en,
        code: item.commodity_code,
        status: item.commodity_status,
        isDangerousGoods: item.isDangerousGoods,
        isQuarantine: item.isQuarantine,
        hsCode: item.hs_code,
        nameId: item.commodity_name,
        nameEn: item.commodity_name_en
      };
    });
  }

  get supportingDocumentErrorMessage() {
    const message = [
      this.indexImageIdUrl <= this.currentIndex
        ? this.error.idImageDocInternational
        : "",
      this.indexImageTaxUrl <= this.currentIndex
        ? this.error.taxImageDocInternational
        : "",
      this.indexImageAfterPackingUrl <= this.currentIndex
        ? this.error.packageAfterPackingImageDocInternational
        : "",
      this.indexImageBeforePackingUrl <= this.currentIndex
        ? this.error.packageBeforePackingImageDocInternational
        : ""
    ];

    return message.filter((msg) => !!msg)[0];
  }

  get shipmentStatusOptions() {
    return [
      new OptionsClass({ name: "Ecommerce", value: "ecommerce" }),
      new OptionsClass({ name: "Produk lokal / Batam", value: "batam" }),
      new OptionsClass({ name: "Eks luar Batam / transit", value: "transit" }),
      new OptionsClass({ name: "Salah kirim / return", value: "return" }),
      new OptionsClass({ name: "Personal effect", value: "personal-effect" })
    ];
  }

  get shipmentStatusInterpackOptions() {
    return [
      new OptionsClass({ name: "Select shipment status", value: "" }),
      new OptionsClass({ name: "Retail", value: "retail" }),
      new OptionsClass({ name: "Diplomatic Pouch", value: "diplomatic-pouch" }),
      new OptionsClass({ name: "Personal Effect", value: "personal-effect" }),
      new OptionsClass({ name: "Marketplace", value: "ecommerce" })
    ];
  }

  get isOtherCommodityRequired() {
    if (this.isFtz) return true;
    return this.internationalDocumentDetailData.commodity;
  }

  get isEmailRequred() {
    return !this.isFtz && this.internationalDocumentDetailData.email;
  }

  get isIdentityNumberRequired() {
    return (
      !this.isFtz && this.internationalDocumentDetailData.idcIsIdentityNumber
    );
  }

  get isTaxNumberRequired() {
    return (
      !this.isFtz &&
      this.internationalDocumentDetailData.idcIsTaxIdentificationNumber
    );
  }

  get isIdentityImageRequired() {
    return !this.isFtz && this.internationalDocumentDetailData.ktp;
  }

  get isTaxImageRequired() {
    return !this.isFtz && this.internationalDocumentDetailData.npwp;
  }

  get isDutyTaxTermsRequired() {
    return !this.isFtz && this.internationalDocumentDetailData.idcIsDutyTaxTerms;
  }

  get isBeforeAndAfterPackingImageRequired() {
    this.modelValue.imageAfterPackingUrl;
    this.modelValue.imageBeforePackingUrl;
    this.modelValue.imageIdUrl;
    this.modelValue.imageTaxUrl;
    return !this.isFtz && this.internationalDocumentDetailData.afterPacking;
  }

  get imageAfterPackingUrl() {
    if (typeof this.modelValue.imageAfterPackingUrl === "string")
      return this.modelValue.imageAfterPackingUrl;
    return "";
  }

  get iamgeBeforePackingUrl() {
    if (typeof this.modelValue.imageBeforePackingUrl === "string")
      return this.modelValue.imageBeforePackingUrl;
    return "";
  }

  get imageIdUrl() {
    if (typeof this.modelValue.imageIdUrl === "string")
      return this.modelValue.imageIdUrl;
    return "";
  }

  get imageTaxUrl() {
    if (typeof this.modelValue.imageTaxUrl === "string")
      return this.modelValue.imageTaxUrl;
    return "";
  }

  formatCIPLGoodsPrice(value = 0) {
    return this.accountIsNonForeign
      ? formatInputMoney(value.toString().replace(/[\D]+/g, ""))
      : formatInputMoneyWithDecimal(value);
  }

  getTranslationText(translationKey = "") {
    if (this.isFtz) {
      return this.$t("bookingV3.docInternational." + translationKey + "FTZ");
    }

    return this.$t("bookingV3.docInternational." + translationKey);
  }

  handleInputCommodity(searchValue = "", fieldIndex = 0) {
    if (searchValue) {
      this.listCommodityCIPL[fieldIndex].commodity = new CommodityData({
        name: searchValue,
        code: searchValue
      });
      this.listCommodityCIPL[fieldIndex].name = searchValue;
      this.validateCIPLCommodity(fieldIndex);
    }

    this.fetchCommodityList(searchValue);
  }

  fetchCommodityList = debounce(async (searchValue = "", fieldIndex = 0) => {
    const commodities = await CommodityController.getCommodityList(
      new RequestListCommodity({
        search: searchValue,
        page: 1,
        limit: 20,
        commodityStatus: "active"
      })
    );
    this.dataListCommodities = commodities.data;
  }, 250);
  async fetchCommodityListInfiniteScroll(search = "") {
    CommodityController.commodities.pagination.page++;
    const commodities = await CommodityController.getCommodityList(
      new RequestListCommodity({
        search,
        page: CommodityController.commodities.pagination.page,
        limit: 20,
        commodityStatus: "active"
      })
    );
    this.dataListCommodities.push(...commodities.data);
  }
  changeCommodities(commodityValue: CommodityData, fieldIndex = 0) {
    this.errorCommodity = !this.listCommodityCIPL[fieldIndex].commodity;
    this.isCommodityNotFound = false;
    this.listCommodityCIPL[fieldIndex].name = commodityValue.name || "";
  }

  onFocusCommodityList(parentIndexField = 0) {
    this.isFocused = true;
    if (!this.listCommodityCIPL[parentIndexField].commodity?.id) {
      this.getCommodityList();
    }
  }

  async getCommodityList() {
    this.dataListCommodities = await this.getCommodities({ limit: 20 });
  }

  async getCommodities(options: {
    limit: number;
    isRecommendedOnly?: boolean;
    page?: number;
    commodityStatus?: string;
  }) {
    const commodities = await CommodityController.getCommodityList(
      new RequestListCommodity({
        page: options.page || 1,
        limit: options.limit,
        commodityStatus: options.commodityStatus || "active",
        ...(options.isRecommendedOnly && {
          isRecommendedOnly: options.isRecommendedOnly
        })
      })
    );
    return commodities.data;
  }

  async onAddCIPL(isInitial = false) {
    if (this.listCommodityCIPL.length >= this.MAX_CIPL) return;

    let lastIndex = 0;
    if (this.listCommodityCIPL.length) {
      lastIndex =
        this.listCommodityCIPL[this.listCommodityCIPL.length - 1]
          .indexGoodsPrice - this.indexListCommodityCIPL;
      lastIndex = Number(lastIndex.toFixed(3));
    }
    this.error.listCommodityCIPLDocInternational.push(["", "", ""]);
    this.listCommodityCIPL.push({
      id: new Date().getTime(),
      indexCommodity: this.indexListCommodityCIPL + (lastIndex + 0.01),
      indexQuantity: this.indexListCommodityCIPL + (lastIndex + 0.02),
      indexGoodsPrice: this.indexListCommodityCIPL + (lastIndex + 0.03),
      commodity: new CommodityData({
        name: "",
        code: ""
      }),
      name: "",
      quantity: "",
      goodsPrice: ""
    });

    if (isInitial) return;
    await this.$nextTick();
    (this.$refs[
      `inputCommodity${this.listCommodityCIPL.length - 1}`
    ] as any).$refs.selectSearch.focus();
  }

  onDeleteCIPL(index = 0) {
    if (!this.getRuleTFtzCiplDisabled) {
      this.listCommodityCIPL.splice(index, 1);
      this.error.listCommodityCIPLDocInternational.splice(index, 1);
    }
  }

  clickViewAll(index = 0) {
    if (this.getRuleTFtzCiplDisabled || this.getRuleTInterCiplDisabled) return;
    this.selectedCIPLIndex = index;
    this.isModalViewAll = !this.isModalViewAll;
  }

  onChooseCommodity(val: Commodity) {
    const commodityName = this.accountIsNonForeign
      ? val.commodity_name
      : val.commodity_name_en || " ";
    this.listCommodityCIPL[this.selectedCIPLIndex].commodity = {
      id: val.commodity_id,
      name: commodityName,
      code: val.commodity_code,
      status: val.commodity_status,
      isDangerousGoods: val.isDangerousGoods,
      isQuarantine: val.isQuarantine,
      hsCode: val.hs_code,
      nameId: val.commodity_name,
      nameEn: val.commodity_name_en
    } as any;
    this.listCommodityCIPL[this.selectedCIPLIndex].name = commodityName;
    this.validateCIPLCommodity(this.selectedCIPLIndex);
    this.selectedCIPLIndex = 0;
  }

  decideBorderBottomTableColumn(index = 0) {
    return (this.listCommodityCIPL.length > 1 && index == 0) ||
      (index > 0 && index !== this.listCommodityCIPL.length - 1)
      ? "border-b border-gray-lp-2100"
      : "";
  }

  async updateFIeldIndex(index = 0) {
    if (index > this.currentIndex && index !== this.currentIndex) {
      this.$emit("update:currentIndex", index);
    }

    await this.$nextTick();

    const validationObj = {
      [this.indexEmail]: this.validateEmail,
      [this.indexIdNumber]: this.validateIdNumber,
      [this.indexTaxNumber]: this.validateTaxNumber,
      [this.indexImageIdUrl]: this.validateImageId,
      [this.indexImageTaxUrl]: this.validateImageTax,
      [this.indexImageBeforePackingUrl]: this.validateImageBeforePacking,
      [this.indexImageAfterPackingUrl]: this.validateImageAfterPacking
    };

    for (let i = 0; i < index; i++) {
      if (validationObj[i]) {
        validationObj[i]();
      }
    }

    const ciplFieldIndex = this.listCommodityCIPL.findIndex(
      (cipl) =>
        cipl.indexCommodity === index ||
        cipl.indexGoodsPrice === index ||
        cipl.indexQuantity === index
    );

    for (let i = 0; i < ciplFieldIndex + 1; i++) {
      this.validateCIPLCommodity(i, index);
      this.validateCIPLQuantity(i, index);
      this.validateCIPLGoodsPrice(i, index);
    }

    this.handleTriggerErrorCIPL(index, ciplFieldIndex);
  }

  handleTriggerErrorCIPL(index = 0, ciplFieldIndex: number) {
    if (ciplFieldIndex !== -1) return;
    if (this.indexListCommodityCIPL < index) {
      for (let i = 0; i < this.listCommodityCIPL.length; i++) {
        this.validateCIPLCommodity(i);
        this.validateCIPLQuantity(i);
        this.validateCIPLGoodsPrice(i);
      }
    }
  }

  resetErrorChangeDest() {
    this.error.emailDocInternational = "";
    this.error.idNumberDocInternational = "";
    this.error.taxNumberDocInternational = "";
    this.error.idImageDocInternational = "";
    this.error.taxImageDocInternational = "";
    this.error.packageBeforePackingImageDocInternational = "";
    this.error.packageAfterPackingImageDocInternational = "";
    this.error.listCommodityCIPLDocInternational.forEach((_, index) => {
      this.error.listCommodityCIPLDocInternational[index] = ["", "", ""];
    });
  }

  validateEmail() {
    const message = parseZodError(
      emailSchema(this.isEmailRequred, this.isFtz, this.modelValue.email),
      this.modelValue.email
    );
    this.error.emailDocInternational = message;
  }

  validateIdNumber() {
    const message = parseZodError(
      idNumberSchema(this.isIdentityNumberRequired),
      this.modelValue.idNumber
    );
    this.error.idNumberDocInternational = message;
  }

  validateTaxNumber(e: any) {
    const maxSize = this.isFtz ? 16 : 100;
    const minSize = this.isFtz ? 15 : 1;
    if (typeof this.modelValue.taxNumber === "string")
      this.modelValue.taxNumber = this.modelValue.taxNumber.slice(
        0,
        maxSize - 1
      ); // implement max-size here, not in the lp-input component.
    const message = parseZodError(
      taxNumberSchema(
        this.isTaxNumberRequired,
        this.isFtz,
        this.modelValue.taxNumber,
        maxSize,
        minSize
      ),
      this.modelValue.taxNumber
    );
    this.error.taxNumberDocInternational = message;
  }

  async validateCIPLCommodity(index = 0, fieldIndex = -1) {
    if (!this.isOtherCommodityRequired) return;
    if (this.$nextTick) await this.$nextTick();
    if (this.modelValue.listCommodityCIPL[index].indexCommodity === fieldIndex)
      return;
    if (!this.error.listCommodityCIPLDocInternational[index]) return;
    const commodityMessage = parseZodError(
      itemDetailSchema,
      this.modelValue.listCommodityCIPL[index].name || ""
    );
    this.error.listCommodityCIPLDocInternational[index][0] = commodityMessage;
  }

  validateCIPLQuantity(index = 0, fieldIndex = -1) {
    if (!this.isOtherCommodityRequired) return;
    if (this.modelValue.listCommodityCIPL[index].indexQuantity === fieldIndex)
      return;
    if (!this.error.listCommodityCIPLDocInternational[index]) return;
    const quantityMessage = parseZodError(
      quantitySchema,
      this.modelValue.listCommodityCIPL[index].quantity
    );
    this.error.listCommodityCIPLDocInternational[index][1] = quantityMessage;
  }

  validateCIPLGoodsPrice(index = 0, fieldIndex = -1) {
    if (!this.isOtherCommodityRequired) return;
    if (this.modelValue.listCommodityCIPL[index].indexGoodsPrice === fieldIndex)
      return;
    if (!this.error.listCommodityCIPLDocInternational[index]) return;
    const goodsPriceMessage = parseZodError(
      goodsPriceSchema,
      this.modelValue.listCommodityCIPL[index].goodsPrice
    );
    this.error.listCommodityCIPLDocInternational[index][2] = goodsPriceMessage;
  }

  validateImageId(file: any = null) {
    const image: any = this.modelValue.imageIdUrl || file;
    const message = parseZodError(
      imageSchema(this.isIdentityImageRequired, image),
      image
    );
    this.error.idImageDocInternational = message;
    if (message.includes("5 MB")) this.modelValue.imageIdUrl = "";
  }

  validateImageTax(file: any = null) {
    const image: any = this.modelValue.imageTaxUrl || file;
    const message = parseZodError(
      imageSchema(this.isTaxImageRequired, image),
      image
    );
    this.error.taxImageDocInternational = message;
    if (message.includes("5 MB")) this.modelValue.imageTaxUrl = "";
  }

  validateImageBeforePacking(file: any = null) {
    const image: any = this.modelValue.imageBeforePackingUrl || file;
    const message = parseZodError(
      imageSchema(this.isBeforeAndAfterPackingImageRequired, image),
      image
    );
    this.error.packageBeforePackingImageDocInternational = message;
    if (message.includes("5 MB")) this.modelValue.imageBeforePackingUrl = "";
  }

  validateImageAfterPacking(file: any = null) {
    const image: any = this.modelValue.imageAfterPackingUrl || file;
    const message = parseZodError(
      imageSchema(this.isBeforeAndAfterPackingImageRequired, image),
      image
    );
    this.error.packageAfterPackingImageDocInternational = message;
    if (message.includes("5 MB")) this.modelValue.imageAfterPackingUrl = "";
  }

  decideShowError(errorMessage = "", fieldIndex = 0) {
    if (fieldIndex <= this.currentIndex) return errorMessage;
    return "";
  }

  async uploadImageToHydra(uploadData: UploadMultiple) {
    MainAppController.showLoading();
    try {
      const fileLink = await BookingController.uploadHydraFile(
        new UploadHydraFileRequest({
          attachFile: uploadData.file,
          folderPath: "/stt"
        })
      );

      return fileLink;
    } finally {
      MainAppController.closeLoading();
    }
  }

  async onUploadIdImage(uploadData: UploadMultiple) {
    if (!uploadData.file) return;
    try {
      const fileLink = await this.uploadImageToHydra(uploadData);
      this.modelValue.imageIdUrl = fileLink.data;
      this.imageIdUrlTemp = this.modelValue.imageIdUrl;
    } catch (err) {
      this.error.idImageDocInternational = "Error Upload KTP Image";
    }
  }

  async onUploadTaxImage(uploadData: UploadMultiple) {
    if (!uploadData.file) return;
    try {
      const fileLink = await this.uploadImageToHydra(uploadData);
      this.modelValue.imageTaxUrl = fileLink.data;
      this.imageTaxUrlTemp = this.modelValue.imageTaxUrl;
    } catch (err) {
      this.error.taxImageDocInternational = "Error Upload Tax Image";
    }
  }

  async onUploadBeforePackingImage(uploadData: UploadMultiple) {
    if (!uploadData.file) return;
    try {
      const fileLink = await this.uploadImageToHydra(uploadData);
      this.modelValue.imageBeforePackingUrl = fileLink.data;
      this.imageBeforePackingUrlTemp = this.modelValue.imageBeforePackingUrl;
    } catch (err) {
      this.error.packageBeforePackingImageDocInternational =
        "Error Upload Before Packing Image";
    }
  }

  async onUploadAfterPackingImage(uploadData: UploadMultiple) {
    if (!uploadData.file) return;
    try {
      const fileLink = await this.uploadImageToHydra(uploadData);
      this.modelValue.imageAfterPackingUrl = fileLink.data;
      this.imageAfterPackingUrlTemp = this.modelValue.imageAfterPackingUrl;
    } catch (err) {
      this.error.packageAfterPackingImageDocInternational =
        "Error Upload After Packing Image";
    }
  }

  formatCIPLQuantity(value: string) {
    const noDecimal = formatInputNoDecimal(String(value));
    return noDecimal;
  }

  formatCIPLQuantityNomorOnly(value: string) {
    const noDecimal = formatInputNumberOnly(String(value));
    return noDecimal;
  }

  formatNomorOnly(value: string, ableInputZero = false) {
    const noDecimal = !ableInputZero
      ? formatInputNumberOnlyV2(String(value))
      : formatNumberOnlyWithZero(String(value), ableInputZero);
    return noDecimal;
  }

  async onRemoveImage(value = "") {
    const payload = new DeleteHydraFileRequest({
      attachFiles: [value]
    });

    await BookingController.deleteHydraFile(payload);
  }

  initShipmentStatus() {
    if (
      this.modelValue.shipmentStatus &&
      typeof this.modelValue.shipmentStatus === "string"
    ) {
      const option = this.shipmentStatusOptions.find(
        (sts) => sts.value === (this.modelValue.shipmentStatus as any)
      );
      this.modelValue.shipmentStatus = option as any;
    }
  }

  async hideTooltip(event: any) {
    const refs: any = this.$refs;
    refs["duty-tax-terms-tooltip"].hide(event);
  }

  async toggleTooltip(event: any) {
    const refs: any = this.$refs;
    refs["duty-tax-terms-tooltip"].show(event);
    await this.$nextTick();
    const container = document.getElementById(
      "duty-tax-terms-tooltip-container"
    );
    if (!container) return;
    absolutePosition(
      container,
      event.currentTarget,
      refs["duty-tax-terms-tooltip"].visible,
      "center"
    );
  }

  get dutyTaxTermsTooltipContent() {
    return [
      `<strong>Delivered Duty Paid (DDP):</strong> ${this.converLanguagelabel().DDP.desc}`,
      `<strong>Delivery At Place (DAP):</strong> ${this.converLanguagelabel().DAP.desc}`
    ];
  }

  get tooltipStyle() {
    return {
      fontFamily: "Montserrat",
      width: "400px",
      backgroundColor: "#4D4D4D",
      color: "#FFFFFF",
      fontSize: "12px",
      marginTop: "20px",
      visibility: "hidden"
    };
  }

  converLanguagelabel() {
    return {
      "DAP": {
        "label": AccountController.accountData.accountIsForeign ? "Paid by Recipient (DAP)" : "Ditanggung penerima (DAP)", 
        "banner": AccountController.accountData.accountIsForeign ? "If any customs duties and taxes apply, the charges will be billed to <strong>recipient</strong>." : "Jika terdapat biaya Bea Cukai & Pajak, maka biaya tersebut akan dibebankan ke <strong>penerima</strong>.",
        "desc": AccountController.accountData.accountIsForeign ? "The recipient will cover all customs duties and taxes when the package arrives at its destination." : "Penerima akan menanggung seluruh biaya bea cukai & pajak saat paket sampai di tujuan.", 
      },
      "DDP": {
        "label": AccountController.accountData.accountIsForeign ? "Paid by Shipper (DDP)" : "Ditanggung pengirim (DDP)",
        "banner": AccountController.accountData.accountIsForeign ? "If any customs duties and taxes apply, the charges will be billed to <strong>shipper</strong>." : "Jika terdapat biaya Bea Cukai & Pajak, maka biaya tersebut akan dibebankan ke <strong>pengirim</strong>.",
        "desc": AccountController.accountData.accountIsForeign ? "The shipper will cover all customs duties and taxes." : "Pengirim akan menanggung seluruh biaya bea cukai & pajak.", 
      }
    }
  }

  get infobarDescription() {
    return this.modelValue.dutyTaxTerms === "DAP"
      ? this.converLanguagelabel().DAP.banner 
      : this.converLanguagelabel().DDP.banner 
  }

  get dutyTaxTermsOptions() {
    return [
      {
        name: this.converLanguagelabel().DAP.label, 
        value: "DAP"
      },
      {
        name: this.converLanguagelabel().DDP.label, 
        value: "DDP"
      }
    ];
  }

  get dutyTaxTermsSingleOptions() {
    return [
      {
        name: this.converLanguagelabel().DAP.label, 
        value: "DAP"
      }
    ];
  }

  onSelectDutyTaxTerms(items: any) {
    this.modelValue.dutyTaxTerms = items.value;
  }
}
